import gql from 'graphql-tag'

export const COURSE_COMPLETIONS_QUERY = gql`
    query CourseCompletions($filter: CourseCompletionFilterInput, $first: Int) {
        courseCompletions(filter: $filter, first: $first) {
            nodes {
                completedAt
                createdAt
                expiresAt
                id
                updatedAt
                course {
                    code
                    description
                    id
                    names {
                        language
                        value
                    }
                }
            }
            pageInfo {
                endCursor
                hasNextPage
                hasPreviousPage
                startCursor
            }
        }
    }
`
